module.exports = __webpack_public_path__ + "cd5880d74ff3b75820dce873e02f5ce0.png";